export default __webpack_public_path__ + "static/cooking-1c4524a2372a56002928ba43bb57efcd.gif";